function modifyWishlistProducts() {
  const wishlistItems = document.querySelectorAll('div#ZoomyWishlistPage .ZoomyWishlistPageGrid');

  wishlistItems.forEach(item => {
    const priceElement = item.querySelector('span.zprice');
    if (priceElement) {
      const price = parseFloat(priceElement.textContent.replace('$', '').trim());
      if (price === 0.00) {
        priceElement.remove(); 

        const addToCartButton = item.querySelector('.addcartbtn');
        if (addToCartButton) {
          addToCartButton.textContent = 'Shop Now'; 
          const productUrl = item.querySelector('a[href]')?.getAttribute('href');
          if (productUrl) {
            addToCartButton.addEventListener('click', (e) => {
              e.preventDefault();
              window.location.href = productUrl;
            });
          }
        }
      }
    }
  });
}

function setupWishlistObserver() {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        const wishlistPage = document.querySelector('div#ZoomyWishlistPage');
        if (wishlistPage) {
          setTimeout(modifyWishlistProducts, 100);
          break;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function initWishlistModification() {
  if (window.location.href.includes('wishlist')) {
    modifyWishlistProducts(); 
    setupWishlistObserver(); 
  }
}

initWishlistModification();
